const QUERIES = {
  USERS_LIST: 'users-list',
}
const BaseNames = {
  PRIMARY_Name : 'Source',
  SECONDARY_Name : 'Destination',
}

export {QUERIES, BaseNames};
